import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

export function FieldInput({ field, value, onChange, testid }) {
  if (field.type === "textarea") {
    return <Textarea data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} />;
  }
  if (field.type === "select") {
    return (
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Select..." /></SelectTrigger>
        <SelectContent>
          {field.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    );
  }
  return <Input data-testid={testid} type={field.type === "date" ? "date" : field.type === "time" ? "time" : "text"}
    value={value || ""} onChange={(e) => onChange(e.target.value)} />;
}

export default function RecordDialog({ open, onClose, onSave, fields, initial, title }) {
  const [form, setForm] = useState(initial || {});

  const submit = async (e) => {
    e.preventDefault();
    await onSave(form);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="record-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{title}</DialogTitle>
          <DialogDescription>Fields marked encrypted are stored securely and visible to admins only.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
          {fields.map((f) => (
            <div key={f.key} className="space-y-1.5">
              <Label className="flex items-center gap-1.5">
                {f.label}{f.sensitive && <span className="text-[10px] uppercase tracking-wide text-primary">encrypted</span>}
              </Label>
              <FieldInput field={f} value={form[f.key]} testid={`record-field-${f.key}`}
                onChange={(v) => setForm({ ...form, [f.key]: v })} />
            </div>
          ))}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" data-testid="record-save-button" className="font-semibold">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
